import { NumberUtils } from '@pk/powerkioskutils';

export class ViewSupplierHistoricalActivitySummary {
	public totalContracts: number;
	public totalAnnualVolumeElec: number;
	public totalAnnualVolumeGas: number;
	public totalTermVolumeElec: number;
	public totalTermVolumeGas: number;
	public totalAnnualVolumeElecMWh: number;
	public totalAnnualVolumeGasDth: number;
	public totalTermVolumeElecMWh: number;
	public totalTermVolumeGasDth: number;

	constructor(data?: Partial<ViewSupplierHistoricalActivitySummary>) {
		Object.assign(this, data);
		this.totalAnnualVolumeElecMWh = NumberUtils.amountToUnits(this.totalAnnualVolumeElec, 'mwh');
		this.totalAnnualVolumeGasDth = NumberUtils.amountToUnits(this.totalAnnualVolumeGas, 'dth');
		this.totalTermVolumeElecMWh = NumberUtils.amountToUnits(this.totalTermVolumeElec, 'mwh');
		this.totalTermVolumeGasDth = NumberUtils.amountToUnits(this.totalTermVolumeGas, 'dth');
	}
}
